import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "@components/Button";
import { Checkmark16Icon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { useTranslationArray } from "@hooks/useTranslationArray";
import { type IUseModalProps } from "@store/modal/modal";
import { type AddBillEmailOption } from "../AddBillEmailVariantModalTypes";

interface IAddBillEmailVariantSelectedOptionModalProps extends IUseModalProps {
  variant: AddBillEmailOption;
  billForwardEmail: string;
}

export const AddBillEmailVariantSelectedOptionModal: React.FC<
  IAddBillEmailVariantSelectedOptionModalProps
> = (props) => {
  const { variant, billForwardEmail, ...rest } = props;
  const modal = useModal(rest);
  const { t } = useTranslation();

  const options = useTranslationArray(
    `addBillEmailVariantModal.${variant}.option`,
  );

  return (
    <Modal
      modal={modal}
      title={
        <span className="pr-8">
          {t(`addBillEmailVariantModal.${variant}.title`)}
        </span>
      }
      className="md:max-w-2xl"
      actionButtons={
        <React.Fragment>
          <Button variant="secondary" onClick={modal.close} className="w-full">
            {t("common.form.buttons.cancel")}
          </Button>
          <Button className="w-full" onClick={modal.close}>
            {t("common.form.buttons.confirm")}
          </Button>
        </React.Fragment>
      }
    >
      <div className="flex flex-col gap-2 text-lg">
        {options?.map((option, index) => (
          <div key={index} className="flex gap-2 text-sm text-grey-dark">
            <div className="mt-0.5 flex size-4 min-w-4 items-center justify-center">
              <Checkmark16Icon className="size-3 stroke-2 text-base-green" />
            </div>
            <span>
              <Trans
                i18nKey={option}
                components={{
                  span: <span className="text-base-black" />,
                }}
                values={{ email: billForwardEmail }}
              />
            </span>
          </div>
        ))}
        <span className="mt-2 text-sm">
          {t(`addBillEmailVariantModal.${variant}.footer`)}
        </span>
      </div>
    </Modal>
  );
};
